import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

interface StatisticCardProps {
  title: string;
  total: number | string;

  redirectUrl: string;
  percentage?: number;
}

function StatisticCard({ title, total, redirectUrl, percentage = 2.5 }: StatisticCardProps) {
  const navigate = useNavigate();
  const isPositive = percentage >= 0;

  const handleClick = () => {
    if (redirectUrl) {
      navigate(redirectUrl);
    }
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.05), 0 2px 4px -2px rgb(0 0 0 / 0.05)",
        borderRadius: "12px",
        border: "none",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": {
          cursor: "pointer",
          transform: "translateY(-2px)",
          boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        },
      }}
    >
      <CardContent sx={{ p: 3, "&:last-child": { pb: 3 } }}>
        <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1}>
          {/* Top Label / Title (Enlarged and crisply tracked) */}
          <Typography
            sx={{
              fontSize: 13.5,
              fontWeight: 650,
              color: "#64748B",
              letterSpacing: "0.01em",
              lineHeight: 1.3,
            }}
          >
            {title}
          </Typography>

          {/* Number Value (Prominent, bold executive typography) */}
          <Typography
            sx={{
              fontSize: { xs: 32, sm: 36 },
              fontWeight: 800,
              letterSpacing: "-0.03em",
              color: "#0F172A",
              lineHeight: 1.1,
              fontFeatureSettings: '"tnum"',
            }}
          >
            {typeof total === "number" ? total.toLocaleString() : total || 0}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

export default StatisticCard;
